var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52026 9.9462C3.52026 7.75132 5.29956 5.97201 7.49445 5.97201H21.9461C24.141 5.97201 25.9203 7.75132 25.9203 9.9462V19.5806C25.9203 21.7755 24.141 23.5548 21.9461 23.5548H7.49445C5.29956 23.5548 3.52026 21.7755 3.52026 19.5806V9.9462Z",
    stroke: "#273239",
    strokeWidth: 1.68602
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7295 14.7621C13.6915 14.7506 12.738 14.4742 11.8729 13.9227C10.5515 13.0795 9.23078 12.2349 7.91139 11.3891C7.573 11.1725 7.43094 10.8498 7.52073 10.5266C7.66681 10.0008 8.26787 9.7797 8.75904 10.085C9.40434 10.4854 10.0402 10.9 10.6795 11.3088C11.3469 11.7355 12.0136 12.1629 12.681 12.5891C14.0051 13.4343 15.4364 13.4343 16.7645 12.5871C18.0578 11.7612 19.3484 10.9308 20.6437 10.1075C21.1616 9.77778 21.7748 9.98666 21.9208 10.533C22.0079 10.8569 21.8672 11.1738 21.5241 11.3942C20.5385 12.0273 19.5507 12.6572 18.563 13.2871C18.1597 13.5442 17.7596 13.8071 17.3482 14.0526C16.5481 14.5301 15.6676 14.7461 14.7302 14.7634L14.7295 14.7621Z",
    fill: "#273239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d70c489257b303bb0df14dee94ddf2f4.svg";
export { ForwardRef as ReactComponent };